module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“We both know this marriage is one of convenience, a business arrangement.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("Exactly what Elizabeth wanted to hear, wasn’t it? Then why did Ted’s words sting? Well, business arrangement or not, how could she wed a stranger? “I…I can’t marry you.”")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("Ted turned to her, searching her face. His expression softened. He took her hand in his. His gentle touch gave her a measure of comfort…and far too much awareness of the man.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("“This isn’t easy for either of us,” he said, his eyes filling with tenderness. “But I want you to know I’ll be kind to you. Work hard to provide for you. I don’t have much, but all I have is yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("Elizabeth didn’t want to marry, but what choice did she have? She didn’t have a penny to her name. Didn’t have a single idea what to do.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("A proposal would solve all her problems.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("Except this proposal was offered to another woman. What would Ted say once he knew her true identity?")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page01"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36133a0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/substitutebridethe_fm01.vue
// module id = 57
// module chunks = 0